<template>
  <div ref="report" class="rp-page service-profit">
    <div class="rp-container">
      <div class="rp-header">
        <div class="d-flex align-items-center">
          <button class="rp-back" title="Orqaga" aria-label="Orqaga" @click="$router.push('/xisobot/main')"><b-icon icon="chevron-left"></b-icon></button>
          <h2 class="rp-title"><b-icon icon="gear-fill" class="mr-2"></b-icon>Service foyda zarari</h2>
        </div>
        <button class="rp-btn rp-btn-primary" @click="fetch" :disabled="loading"><b-icon icon="arrow-repeat"></b-icon> Yangilash</button>
      </div>

      <div class="rp-filters">
        <div class="rp-filter"><label for="sp-start">Boshlang'ich sana</label><input id="sp-start" type="date" v-model="date1" @change="fetch"></div>
        <div class="rp-filter"><label for="sp-end">Tugash sana</label><input id="sp-end" type="date" v-model="date2" @change="fetch"></div>
        <div class="rp-filter rp-filter-grow">
          <label>Sklad</label>
          <v-select :options="skladList" v-model="sklad_id" :reduce="s => s.id" label="name" placeholder="Barchasi" @input="fetch" />
        </div>
      </div>

      <div v-if="error" class="sp-alert" role="alert">{{ error }}</div>
      <div v-if="!loading && totals.unclassified_expense > 0" class="sp-alert" role="status">
        <b-icon icon="exclamation-circle-fill"></b-icon> Tasniflanmagan chiqim: <strong>{{ fmt(totals.unclassified_expense) }} so'm.</strong>
      </div>
      <div v-if="!loading && totals.unallocated_salary > 0" class="sp-alert" role="status">
        Skladga biriktirilmagan ishchilar maoshi: {{ fmt(totals.unallocated_salary) }} so'm. Tanlangan sklad xarajatiga kiritilmagan.
      </div>

      <div class="rp-summary rp-summary-3" :aria-busy="loading">
        <div v-for="metric in metrics" :key="metric.key" class="rp-card">
          <span class="sp-icon" :class="'sp-tone-' + metric.tone"><b-icon :icon="metric.icon"></b-icon></span>
          <div class="sp-metric-copy">
            <div class="rp-card-label">{{ metric.label }}</div>
            <div class="rp-card-value" :class="metric.key === 'total_expense' ? 'rp-red' : metric.profit || metric.key === 'net_profit' ? profitClass(totals[metric.key]) : ''">{{ metric.key === 'net_profit' ? netDisplay(totals) : display(totals[metric.key]) }}</div>
            <span class="sp-unit">so'm</span>
          </div>
          <apexchart v-if="metric.profit && !loading && daily.length" class="sp-spark" type="area" height="54" width="110" :options="sparkOptions(metric.color)" :series="[{name: metric.label, data: daily.map(r => r[metric.key])}]" />
        </div>
      </div>

      <div class="rp-section sp-payment-section">
        <div class="sp-section-head"><h3 class="rp-block-title"><b-icon icon="wallet2"></b-icon> Nasiya va nasiyasiz savdolar</h3><button class="rp-btn rp-btn-secondary" :disabled="loading" @click="exportExcel('payment')"><b-icon icon="file-earmark-spreadsheet"></b-icon> Excel</button></div>
        <div class="rp-table-wrap"><table class="rp-table">
          <thead><tr><th>Savdo paytidagi holat</th><th class="t-center">Soni</th><th class="t-right">Savdo summasi</th><th class="t-right">Mahsulot foydasi</th><th class="t-right">Xizmat foydasi</th><th class="t-right">Peredelka foydasi</th><th class="t-right">Tannarx + usta ulushi</th><th class="t-right">Yalpi foyda</th></tr></thead>
          <tbody><tr v-for="group in salesByPayment" :key="group.type"><td><span class="sp-status" :class="group.type === 'credit' ? 'sp-status-pending' : 'sp-status-ok'">{{ paymentName(group.type) }}</span></td><td class="t-center"><span class="rp-badge rp-badge-blue">{{ loading ? '...' : group.count }}</span></td><td class="t-right rp-blue">{{ display(group.total_revenue) }}</td><td class="t-right" :class="profitClass(group.product_profit)">{{ display(group.product_profit) }}</td><td class="t-right" :class="profitClass(group.service_profit)">{{ display(group.service_profit) }}</td><td class="t-right" :class="profitClass(group.redo_profit)">{{ display(group.redo_profit) }}</td><td class="t-right rp-red">{{ display(group.total_expense) }}</td><td class="t-right" :class="profitClass(group.gross_profit)">{{ display(group.gross_profit) }}</td></tr></tbody>
          <tfoot><tr><th>Jami</th><th class="t-center">{{ loading ? '...' : totals.count }}</th><th v-for="key in paymentKeys" :key="key" class="t-right">{{ display(paymentTotal(key)) }}</th></tr></tfoot>
        </table></div>
      </div>

      <div class="rp-section">
        <div class="sp-section-head"><h3 class="rp-block-title"><b-icon icon="building"></b-icon> Faoliyat bo'yicha hisob</h3><button class="rp-btn rp-btn-secondary" :disabled="loading" @click="exportExcel('activity')"><b-icon icon="file-earmark-spreadsheet"></b-icon> Excel</button></div>
        <div class="rp-table-wrap">
          <table class="rp-table">
            <thead><tr><th>#</th><th>Yo'nalish</th><th class="t-right">Daromad</th><th class="t-right">Xarajat</th><th class="t-right">Foyda</th><th class="t-right">Foyda %</th></tr></thead>
            <tbody>
              <tr v-for="(row, index) in activities" :key="row.name"><td><span class="rp-num">{{ index + 1 }}</span></td><td>{{ row.name }}</td><td class="t-right rp-blue">{{ display(row.revenue) }}</td><td class="t-right rp-red">{{ display(row.expense) }}</td><td class="t-right" :class="profitClass(row.profit)">{{ display(row.profit) }}</td><td><div class="sp-margin" :class="profitClass(row.profit)"><span>{{ loading ? '...' : margin(row.revenue, row.profit) }}</span><span class="sp-track"><i :style="{width: Math.min(100, Math.abs(percent(row.revenue, row.profit))) + '%'}"></i></span></div></td></tr>
            </tbody>
            <tfoot><tr><th colspan="2"><b-icon icon="calculator"></b-icon> Jami</th><th class="t-right rp-blue">{{ display(totals.total_revenue) }}</th><th class="t-right rp-red">{{ display(totals.total_expense) }}</th><th class="t-right" :class="profitClass(totals.net_profit)">{{ netDisplay(totals) }}</th><th class="t-right">{{ complete(totals) ? margin(totals.total_revenue, totals.net_profit) : '-' }}</th></tr></tfoot>
          </table>
        </div>
      </div>

      <div class="sp-ledger">
        <div v-for="item in ledger" :key="item.label" class="sp-ledger-item"><span class="sp-icon" :class="'sp-tone-' + item.tone"><b-icon :icon="item.icon"></b-icon></span><div><span>{{ item.label }}</span><strong :class="item.color">{{ display(item.value) }}</strong><span class="sp-unit">{{ item.unit || "so'm" }}</span></div></div>
      </div>

      <div class="rp-chart-wrap" v-if="!loading && daily.length > 0">
        <div class="sp-section-head"><h3 class="rp-block-title"><span class="sp-heading-icon"><b-icon icon="bar-chart-fill"></b-icon></span> Kunlik dinamika</h3><div class="sp-chart-controls"><input aria-label="Grafik boshlanish sanasi" type="date" v-model="date1" @change="fetch"><input aria-label="Grafik tugash sanasi" type="date" v-model="date2" @change="fetch"><select aria-label="Grafik davri" v-model="chartPeriod"><option value="daily">Kunlik</option><option value="weekly">Haftalik</option><option value="monthly">Oylik</option></select></div></div>
        <apexchart type="bar" height="300" :options="chartOptions" :series="chartSeries"></apexchart>
      </div>

      <div class="rp-section">
        <div class="sp-section-head"><h3 class="rp-block-title"><span class="sp-heading-icon"><b-icon icon="calendar3"></b-icon></span> Kunlik tafsilot</h3><button class="rp-btn rp-btn-secondary" :disabled="loading || !daily.length" @click="exportExcel('daily')"><b-icon icon="file-earmark-spreadsheet"></b-icon> Excel</button></div>
        <div class="rp-table-wrap">
          <table class="rp-table">
            <thead>
              <tr>
                <th>Sana</th><th class="t-center">Soni</th>
                <th class="t-right">Mahsulot foydasi</th><th class="t-right">Xizmat foydasi</th><th class="t-right">Peredelka foydasi</th>
                <th class="t-right">Usta ulushi</th><th class="t-right">Kunlik maosh</th><th class="t-right">Umumiy xarajat</th>
                <th class="t-right">Nasiyasiz savdo</th><th class="t-right">Nasiya savdo</th><th class="t-right">Jami daromad</th><th class="t-right">Jami xarajat</th><th class="t-right">Sof foyda</th><th class="t-center">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in (loading ? [] : daily)" :key="r.day">
                <td class="rp-strong"><b-icon icon="calendar3" class="mr-2"></b-icon>{{ r.day }}</td>
                <td class="t-center"><span class="rp-badge rp-badge-blue">{{ r.count }}</span></td>
                <td class="t-right" :class="profitClass(r.product_profit)">{{ fmt(r.product_profit) }}</td>
                <td class="t-right" :class="profitClass(r.service_profit)">{{ fmt(r.service_profit) }}</td>
                <td class="t-right" :class="profitClass(r.redo_profit)">{{ fmt(r.redo_profit) }}</td>
                <td class="t-right rp-red">{{ fmt(r.master_paid) }}</td>
                <td class="t-right rp-red">{{ fmt(r.daily_salary) }}</td>
                <td class="t-right rp-red">{{ fmt(r.operating_expense + r.labor_expense + r.redo_expense) }}</td>
                <td class="t-right rp-blue">{{ fmt(r.paid_revenue) }}</td>
                <td class="t-right rp-orange">{{ fmt(r.credit_revenue) }}</td>
                <td class="t-right rp-strong">{{ fmt(r.total_revenue) }}</td>
                <td class="t-right rp-red">{{ fmt(r.total_expense) }}</td>
                <td class="t-right" :class="profitClass(r.net_profit)">{{ netDisplay(r) }}</td>
                <td class="t-center"><span class="sp-status" :class="complete(r) ? 'sp-status-ok' : 'sp-status-pending'">{{ complete(r) ? 'Hisoblangan' : 'Aniqlanmagan' }}</span></td>
              </tr>
              <tr v-if="loading"><td colspan="14" class="rp-empty">Yuklanmoqda...</td></tr>
              <tr v-else-if="daily.length === 0"><td colspan="14" class="rp-empty">Ma'lumot yo'q</td></tr>
            </tbody>
            <tfoot v-if="daily.length && !loading"><tr><th>Jami</th><th class="t-center">{{ totals.count }}</th><th v-for="key in dailyKeys" :key="key" class="t-right">{{ key === 'net_profit' ? netDisplay(totals) : fmt(key === 'operating_expense' ? totals.operating_expense + totals.labor_expense + totals.redo_expense : totals[key]) }}</th><th class="t-center">{{ complete(totals) ? 'Hisoblangan' : 'Aniqlanmagan' }}</th></tr></tfoot>
          </table>
        </div>
      </div>

      <div class="rp-section">
        <div class="sp-section-head"><h3 class="rp-block-title"><span class="sp-heading-icon"><b-icon icon="file-earmark-text-fill"></b-icon></span> Kassa order chiqimlari</h3><button class="rp-btn sp-add" @click="openCashOrder()"><b-icon icon="plus-lg"></b-icon> Yangi chiqim</button></div>
        <div class="rp-table-wrap"><table class="rp-table sp-expenses"><thead><tr><th>#</th><th>Asos</th><th>Sklad</th><th>Hisob turi</th><th class="t-right">Summa</th><th>Sanasi</th><th class="t-center">Amal</th></tr></thead><tbody><tr v-for="(item, index) in (loading ? [] : expenseDocuments)" :key="item.doc_id + ':' + item.sklad_id + ':' + item.day + ':' + item.reason"><td><span class="rp-num">{{ index + 1 }}</span></td><td>{{ item.reason }}</td><td>{{ skladName(item.sklad_id) }}</td><td><select v-model="item.expense_type" :disabled="saving" @change="saveExpenseType(item)" :aria-label="item.reason + ' hisob turi'"><option v-for="type in expenseTypes" :key="type.id" :value="type.id">{{ type.name }}</option></select></td><td class="t-right rp-red">{{ fmt(item.summa) }}</td><td>{{ item.day }}</td><td><div class="sp-row-actions"><button class="sp-action" title="Orderni ko'rish" aria-label="Orderni ko'rish" @click="viewExpense(item)"><b-icon icon="eye-fill"></b-icon></button><button class="sp-action sp-edit" title="Orderni tahrirlash" aria-label="Orderni tahrirlash" @click="openCashOrder(item)"><b-icon icon="pencil-fill"></b-icon></button><button class="sp-action sp-delete" title="Butun orderni o'chirish" aria-label="Butun orderni o'chirish" :disabled="saving" @click="deleteExpense(item)"><b-icon icon="trash-fill"></b-icon></button></div></td></tr><tr v-if="loading || !expenseDocuments.length"><td colspan="7" class="rp-empty">{{ loading ? 'Yuklanmoqda...' : "Ma'lumot yo'q" }}</td></tr></tbody></table></div>
      </div>
      <b-modal v-model="expenseVisible" title="Kassa order" hide-footer><div v-if="selectedExpense"><p><strong>{{ selectedExpense.reason }}</strong></p><p>{{ skladName(selectedExpense.sklad_id) }} / {{ selectedExpense.day }}</p><p class="rp-red">{{ fmt(selectedExpense.summa) }} so'm</p><p>{{ (expenseTypes.find(t => t.id === selectedExpense.expense_type) || {}).name }}</p><button class="rp-btn sp-add" @click="openCashOrder(selectedExpense)"><b-icon icon="pencil-fill"></b-icon> Orderni ochish</button></div></b-modal>
    </div>
  </div>
</template>

<script>
import './report.css';
import axios from 'axios';
import * as XLSX from 'xlsx';
const emptyTotals = () => ({ count: 0, product_revenue: 0, product_cost: 0, product_profit: 0,
  labor_revenue: 0, service_profit: 0, redo_revenue: 0, redo_profit: 0, master_paid: 0,
  daily_salary: 0, labor_expense: 0, redo_expense: 0, operating_expense: 0, total_revenue: 0, total_expense: 0, discounts: 0,
  unclassified_expense: 0, excluded_expense: 0,
  net_profit: 0, cash_income: 0, cash_expense: 0, unallocated_salary: 0,
  paid_count: 0, paid_revenue: 0, credit_count: 0, credit_revenue: 0 });
const paymentKeys = ['total_revenue', 'product_profit', 'service_profit', 'redo_profit', 'total_expense', 'gross_profit'];
const emptyPaymentGroups = () => ['paid', 'credit'].map(type => ({type,count:0,...Object.fromEntries(paymentKeys.map(key => [key,0]))}));
export default {
  data() {
    const today = new Date(); const first = new Date(today.getFullYear(), today.getMonth(), 1);
    const query = (this.$route && this.$route.query) || {};
    const date = (value, fallback) => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) && Number.isFinite(this.toUnix(value)) ? value : this.ds(fallback);
    return {
      date1: date(query.date1, first), date2: date(query.date2, today),
      sklad_id: Number.isInteger(Number(query.sklad)) && Number(query.sklad) > 0 ? Number(query.sklad) : null, skladList: [], daily: [],
      totals: emptyTotals(), expenses: [], expenseDocuments: [], error: '', requestId: 0, saving: false,
      chartPeriod: ['daily','weekly','monthly'].includes(query.period) ? query.period : 'daily', expenseVisible: false, selectedExpense: null,
      scrollToRestore: Number.isFinite(Number(query.scroll)) ? Math.max(0, Number(query.scroll)) : 0,
      salesByPayment: emptyPaymentGroups(), paymentKeys,
      metrics: [
        {key:'product_profit',label:'Mahsulot foydasi',icon:'coin',tone:'green',color:'#00a56b',profit:true},
        {key:'service_profit',label:'Xizmat foydasi',icon:'tools',tone:'red',color:'#ff1749',profit:true},
        {key:'redo_profit',label:'Peredelka foydasi',icon:'bar-chart-fill',tone:'blue',color:'#246bff',profit:true},
        {key:'total_revenue',label:'Savdo daromadi (nasiya bilan)',icon:'file-earmark-text-fill',tone:'purple'},
        {key:'total_expense',label:'Jami xarajat',icon:'cart3',tone:'amber'},
        {key:'net_profit',label:'Sof foyda',icon:'question-circle-fill',tone:'neutral',profit:false},
      ],
      expenseTypes: [
        { id: 'unclassified', name: 'Tasniflanmagan' },
        { id: 'operating', name: 'Umumiy xarajat' },
        { id: 'labor', name: 'Xizmat xarajati' },
        { id: 'redo', name: 'Peredelka xarajati' },
        { id: 'product_purchase', name: 'Mahsulot xaridi' },
        { id: 'salary_payment', name: "Hisoblangan maosh to'lovi" },
        { id: 'transfer', name: "Pul o'tkazish" },
      ],
      dailyKeys: ['product_profit', 'service_profit', 'redo_profit', 'master_paid', 'daily_salary', 'operating_expense', 'paid_revenue', 'credit_revenue', 'total_revenue', 'total_expense', 'net_profit'],
      loading: false,
    };
  },
  computed: {
    activities() {
      const t = this.totals;
      return [
        {name:'Mahsulotlar',revenue:t.product_revenue,expense:t.product_cost,profit:t.product_profit},
        {name:'Xizmatlar',revenue:t.labor_revenue,expense:t.master_paid+t.daily_salary+t.labor_expense,profit:t.service_profit},
        {name:'Peredelka',revenue:t.redo_revenue,expense:t.redo_expense,profit:t.redo_profit},
        {name:'Umumiy xarajatlar',revenue:0,expense:t.operating_expense,profit:-t.operating_expense},
      ];
    },
    ledger() {
      const t = this.totals;
      return [
        {label:'Ustalar ulushi',value:t.master_paid,icon:'coin',tone:'blue'},
        {label:'Kunlik ishchilar maoshi',value:t.daily_salary,icon:'tools',tone:'red'},
        {label:'Chegirma',value:t.discounts,icon:'cart3',tone:'green',color:'rp-green'},
        {label:'Savdolar soni',value:t.count,icon:'people-fill',tone:'purple',unit:'ta'},
        {label:'Kassaga kirim',value:t.cash_income,icon:'arrow-up',tone:'green',color:'rp-green'},
        {label:'Kassadan chiqim',value:t.cash_expense,icon:'arrow-down',tone:'red',color:'rp-red'},
        {label:'Kassa farqi',value:t.cash_income-t.cash_expense,icon:'graph-up',tone:'red',color:this.profitClass(t.cash_income-t.cash_expense)},
      ];
    },
    chartRows() {
      if (this.chartPeriod === 'daily') return this.daily;
      const groups = new Map();
      for (const row of this.daily) {
        const date = new Date(row.day + 'T12:00:00');
        if (this.chartPeriod === 'weekly') date.setDate(date.getDate() - (date.getDay() + 6) % 7);
        else date.setDate(1);
        const key = this.ds(date);
        if (!groups.has(key)) groups.set(key, {day:key,product_profit:0,service_profit:0,redo_profit:0,net_profit:0,unclassified_expense:0,unallocated_salary:0});
        const group = groups.get(key);
        for (const field of Object.keys(group)) if (field !== 'day') group[field] += Number(row[field]) || 0;
      }
      return [...groups.values()];
    },
    chartOptions() {
      return {
        chart: { stacked: false, toolbar: { show: false }, fontFamily: 'inherit', animations: {enabled:false} },
        colors: ['#1689ff', '#20af7e', '#ff7c2b', '#7952ff'],
        plotOptions: { bar: { columnWidth: '55%', borderRadius: 4 } },
        stroke: { width: 0 },
        xaxis: { categories: this.chartRows.map(d => d.day), labels: {style:{colors:'#617da9'}} },
        yaxis: { labels: { formatter: v => this.fmt(v) } },
        legend: { position: 'top' },
        dataLabels: { enabled: false },
        tooltip: { y: { formatter: v => this.fmt(v) + " so'm" } },
        grid: { borderColor: '#e8eff8', xaxis:{lines:{show:true}} },
      };
    },
    chartSeries() {
      return [
        { name: 'Mahsulot foydasi', type: 'column', data: this.chartRows.map(d => d.product_profit) },
        { name: 'Xizmat foydasi', type: 'column', data: this.chartRows.map(d => d.service_profit) },
        { name: 'Peredelka foydasi', type: 'column', data: this.chartRows.map(d => d.redo_profit) },
        { name: 'Sof foyda', type: 'column', data: this.chartRows.map(d => this.complete(d) ? d.net_profit : null) },
      ];
    }
  },
  mounted() { this.loadSklads(); this.fetch(); },
  methods: {
    paymentName(type) { return type === 'credit' ? 'Nasiya savdolar' : 'Nasiyasiz savdolar'; },
    paymentTotal(key) { return this.salesByPayment.reduce((total, group) => total + (Number(group[key]) || 0), 0); },
    complete(row) { return !(row.unclassified_expense > 0 || row.unallocated_salary > 0); },
    percent(revenue, profit) { return revenue ? profit / revenue * 100 : 0; },
    margin(revenue, profit) { return revenue ? this.percent(revenue, profit).toLocaleString('ru-RU', {maximumFractionDigits:1}) + '%' : (profit ? '-' : '0%'); },
    sparkOptions(color) { return {chart:{sparkline:{enabled:true},animations:{enabled:false}},colors:[color],stroke:{width:2,curve:'smooth'},fill:{type:'solid',opacity:0.12},tooltip:{enabled:false},dataLabels:{enabled:false}}; },
    exportRows(kind) {
      if (kind === 'payment') return [
        ['Savdo paytidagi holat','Soni','Savdo summasi','Mahsulot foydasi','Xizmat foydasi','Peredelka foydasi','Tannarx + usta ulushi','Yalpi foyda'],
        ...this.salesByPayment.map(group => [this.paymentName(group.type),group.count,...this.paymentKeys.map(key => group[key])]),
        ['Jami',this.totals.count,...this.paymentKeys.map(key => this.paymentTotal(key))],
      ];
      if (kind === 'activity') return [
        ["Yo'nalish",'Daromad','Xarajat','Foyda','Foyda %'],
        ...this.activities.map(r => [r.name,r.revenue,r.expense,r.profit,r.revenue ? this.percent(r.revenue,r.profit) : null]),
        ['Jami',this.totals.total_revenue,this.totals.total_expense,this.complete(this.totals) ? this.totals.net_profit : 'Aniqlanmagan',this.complete(this.totals) && this.totals.total_revenue ? this.percent(this.totals.total_revenue,this.totals.net_profit) : null],
      ];
      const values = r => [r.count,...this.dailyKeys.map(key => key === 'net_profit' && !this.complete(r) ? 'Aniqlanmagan' : key === 'operating_expense' ? r.operating_expense+r.labor_expense+r.redo_expense : r[key]),this.complete(r) ? 'Hisoblangan' : 'Aniqlanmagan'];
      return [['Sana','Soni','Mahsulot foydasi','Xizmat foydasi','Peredelka foydasi','Usta ulushi','Kunlik maosh','Umumiy xarajat','Nasiyasiz savdo','Nasiya savdo','Jami daromad','Jami xarajat','Sof foyda','Status'],...this.daily.map(r => [r.day,...values(r)]),['Jami',...values(this.totals)]];
    },
    excelSheet(kind) {
      const rows = this.exportRows(kind);
      const sheet = XLSX.utils.aoa_to_sheet(rows);
      sheet['!cols'] = rows[0].map(() => ({wch:22}));
      rows.forEach((row, rowIndex) => row.forEach((value, columnIndex) => {
        if (typeof value === 'number' && !(kind === 'activity' && columnIndex === 4)) {
          sheet[XLSX.utils.encode_cell({r:rowIndex,c:columnIndex})].z = '#,##0';
        }
      }));
      return sheet;
    },
    exportExcel(kind) {
      try {
        const book = XLSX.utils.book_new();
        const sheet = this.excelSheet(kind);
        XLSX.utils.book_append_sheet(book,sheet,kind === 'activity' ? 'Faoliyat' : kind === 'payment' ? 'Savdo turlari' : 'Kunlik');
        if (kind !== 'payment') XLSX.utils.book_append_sheet(book,this.excelSheet('payment'),'Savdo turlari');
        XLSX.writeFile(book,`service-foyda-${kind}-${this.date1}-${this.date2}.xlsx`);
      } catch (e) { this.error = "Excel faylini yaratib bo'lmadi."; }
    },
    viewExpense(item) { this.selectedExpense = item; this.expenseVisible = true; },
    async openCashOrder(item) {
      const query = {date1:this.date1,date2:this.date2,sklad:this.sklad_id ? String(this.sklad_id) : '',period:this.chartPeriod,scroll:String(this.$refs.report.scrollTop)};
      try {
        await this.$router.replace({path:'/xisobot/service-profit',query}).catch(error => { if (error.name !== 'NavigationDuplicated') throw error; });
        this.expenseVisible = false;
        await this.$router.push({path:item ? '/kassaorder/update/' + item.doc_id : '/kassaorder/create',query:{...query,returnTo:'service-profit'}});
      } catch (e) { this.error = "Orderni ochib bo'lmadi."; }
    },
    async deleteExpense(item) {
      if (!window.confirm(`${item.day}: ${item.reason}. Butun kassa orderi va undagi barcha kirim/chiqimlar o'chiriladi. Davom etasizmi?`)) return;
      try {
        const warehouse = await axios.get('api/v1/sklads/id/' + item.sklad_id);
        const password = await this.$prompt('O\'chirish parolini kiriting');
        if (!warehouse.data.update_password || password !== warehouse.data.update_password) { this.error = 'Parol xato.'; return; }
        this.saving = true;
        await axios.delete('api/v1/kassa-order/id/' + item.doc_id);
        this.expenseVisible = false;
        await this.fetch();
      } catch (e) { if (e && (e.response || e.message)) this.error = "Orderni o'chirib bo'lmadi."; }
      finally { this.saving = false; }
    },
    ds(d) { return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; },
    toUnix(s, e = false) { return Math.floor(new Date(s + (e ? 'T23:59:59' : 'T00:00:00')).getTime() / 1000); },
    fmt(v) {
      const value = parseFloat(v) || 0;
      return (Math.abs(value) < 0.5 ? 0 : value).toLocaleString('ru-RU', { maximumFractionDigits: 0 });
    },
    display(v) { return this.loading ? '...' : this.fmt(v); },
    netDisplay(row) { return this.loading ? '...' : (row.unclassified_expense > 0 || row.unallocated_salary > 0 ? 'Aniqlanmagan' : this.fmt(row.net_profit)); },
    profitClass(v) { return Number(v) < 0 ? 'rp-red' : 'rp-green'; },
    skladName(id) { const found = this.skladList.find(s => Number(s.id) === Number(id)); return found ? found.name : String(id); },
    async saveExpenseType(item) {
      this.saving = true;
      try {
        if (!item.classification_key) throw new Error('Missing expense identity');
        await axios.patch('api/v1/sklad-settings', { sklad_id: item.sklad_id, key: item.classification_key, data: item.expense_type });
        await this.fetch();
      } catch (e) { await this.fetch(); this.error = "Xarajat turini saqlab bo'lmadi."; }
      finally { this.saving = false; }
    },
    async loadSklads() { try { const r = await axios.get('api/v1/sklads'); this.skladList = r.data || []; } catch (e) {} },
    async fetch() {
      const requestId = ++this.requestId;
      const scroll = this.scrollToRestore !== null ? this.scrollToRestore : this.$refs && this.$refs.report ? this.$refs.report.scrollTop : 0;
      this.error = '';
      if (!this.date1 || !this.date2 || this.date1 > this.date2) {
        this.daily = []; this.expenses = []; this.expenseDocuments = []; this.salesByPayment = emptyPaymentGroups(); this.totals = emptyTotals(); this.loading = false;
        this.error = "Sana oralig'ini to'g'ri tanlang.";
        return;
      }
      this.loading = true;
      try {
        const r = await axios.post('api/v1/report/service-profit/', {
          datetime1: this.toUnix(this.date1), datetime2: this.toUnix(this.date2, true),
          sklad_id: this.sklad_id || null,
        });
        if (requestId !== this.requestId) return;
        this.daily = r.data.daily || [];
        this.expenses = r.data.expenses || [];
        this.expenseDocuments = r.data.expense_documents || [];
        this.salesByPayment = r.data.sales_by_payment || emptyPaymentGroups();
        this.totals = { ...emptyTotals(), ...r.data.totals };
      } catch (e) {
        if (requestId !== this.requestId) return;
        this.daily = []; this.expenses = []; this.expenseDocuments = []; this.salesByPayment = emptyPaymentGroups(); this.totals = emptyTotals();
        this.error = "Hisobotni yuklab bo'lmadi.";
      }
      finally {
        if (requestId === this.requestId) {
          this.loading = false;
          this.scrollToRestore = null;
          if (this.$nextTick) await this.$nextTick();
          if (this.$refs && this.$refs.report) this.$refs.report.scrollTop = scroll;
        }
      }
    }
  }
};
</script>

<style scoped>
.service-profit { background: #eef6ff; padding: 20px 24px; color: #091537; font-family: Arial, Helvetica, sans-serif; }
.service-profit .rp-container { max-width: 1580px; }
.service-profit .rp-header { gap: 12px; flex-wrap: wrap; margin-bottom: 18px; }
.service-profit .rp-title { font-size: 22px; color: #071330; }
.service-profit .rp-title .b-icon { width: 44px; height: 44px; padding: 10px; background: #f8fbff; border-radius: 8px; margin-right: 14px !important; }
.service-profit .rp-back { flex-shrink: 0; width: 44px; height: 44px; border-radius: 8px; background: #2d68ff; color: white; border: 0; margin-right: 22px; }
.service-profit .rp-back:hover { background: #1555e8; }
.service-profit .rp-btn { border-radius: 8px; font-size: 13px; min-height: 40px; white-space: nowrap; }
.service-profit .rp-btn-primary { background: #009bb9; padding: 12px 22px; }
.service-profit .rp-btn-primary:hover { background: #0088a5; }
.service-profit .rp-btn-secondary { color: #14254c; border-color: #d9e4f2; background: #fafcff; font-weight: 600; }
.service-profit .rp-btn-secondary:hover { background: #edf5ff; border-color: #9bbfff; }
.service-profit .rp-filters { gap: 28px; flex-wrap: wrap; border-radius: 8px; padding: 16px; margin-bottom: 12px; border: 0; box-shadow: none; }
.service-profit .rp-filter { flex: 1; min-width: 180px; }
.service-profit .rp-filter-grow { flex: 2; }
.service-profit .rp-filter label { font-size: 11px; letter-spacing: 0; color: #6480aa; }
.service-profit .rp-filter input { height: 38px; border-radius: 6px; border-color: #dce6f4; background: #f7faff; color: #10214a; font-size: 14px; }
.service-profit ::v-deep .vs__dropdown-toggle { border: 1px solid #dce6f4; border-radius: 6px; background: #f7faff; min-height: 38px; }
.service-profit .rp-summary { margin-bottom: 16px; gap: 12px; }
.service-profit .rp-summary-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.service-profit .rp-card { display: flex; align-items: center; gap: 18px; border-radius: 8px; min-width: 0; min-height: 100px; padding: 16px; border: 0; box-shadow: 0 3px 12px rgba(33, 94, 146, 0.035); }
.service-profit .rp-card:hover { transform: none; }
.sp-icon { display: inline-flex; align-items: center; justify-content: center; width: 62px; height: 62px; border-radius: 50%; flex-shrink: 0; font-size: 28px; }
.sp-tone-green { background: #e2f7ef; color: #009c66; }
.sp-tone-red { background: #ffebef; color: #ff1547; }
.sp-tone-blue { background: #e6efff; color: #246aff; }
.sp-tone-purple { background: #f0e7ff; color: #903bf6; }
.sp-tone-amber { background: #fff5df; color: #ed9d00; }
.sp-tone-neutral { background: #edf1f7; color: #7a92b4; }
.sp-metric-copy { flex: 1; min-width: 0; }
.service-profit .rp-card-label { font-size: 11px; color: #6681ad; letter-spacing: 0; margin-bottom: 4px; line-height: 1.4; }
.service-profit .rp-card-value { overflow-wrap: anywhere; font-size: 22px; line-height: 1.2; color: #071331; }
.sp-unit { font-size: 12px; font-weight: 600; color: #637da6; }
.sp-spark { align-self: flex-end; flex-shrink: 0; width: 110px; }
.service-profit .rp-green { color: #008c5a; }
.service-profit .rp-red { color: #ff063a; }
.service-profit .rp-blue { color: #246aff; }
.service-profit .rp-section, .service-profit .rp-chart-wrap { border-radius: 8px; border: 0; box-shadow: none; padding: 16px; margin-bottom: 14px; }
.sp-section-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 14px; flex-wrap: wrap; }
.service-profit .rp-block-title { margin: 0; color: #091537; font-size: 18px; gap: 12px; }
.sp-heading-icon { display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; background: #eef5ff; color: #056aff; border-radius: 8px; }
.service-profit .rp-table { font-size: 13px; }
.service-profit .rp-table th { letter-spacing: 0; border: 0; color: #637fa9; background: #f0f5fc; font-size: 10px; padding: 11px 10px; white-space: nowrap; position: static; }
.service-profit .rp-table td { padding: 9px 10px; color: #15274e; border-color: #edf2fa; white-space: nowrap; }
.service-profit .rp-table td.rp-red { color: #ff063a; }
.service-profit .rp-table td.rp-green { color: #008c5a; }
.service-profit .rp-table td.rp-blue { color: #246aff; }
.service-profit .rp-table td.rp-strong { color: #091a50; }
.service-profit .rp-table tbody tr:nth-child(even), .service-profit .rp-table tbody tr:hover { background: #f6f9fd; }
.service-profit .rp-table .t-right { text-align: right; }
.service-profit .rp-table .t-center { text-align: center; }
.service-profit .rp-table tfoot th { background: #fff5d3; border: 0; padding: 14px 10px; color: #703605; font-size: 12px; }
.service-profit .rp-table tfoot th.rp-green { color: #008c5a; }
.service-profit .rp-table tfoot th.rp-red { color: #ff063a; }
.service-profit .rp-table tfoot th.rp-blue { color: #246aff; }
.service-profit .rp-num { background: #eaf0f7; color: #405779; }
.sp-margin { display: flex; gap: 20px; justify-content: flex-end; align-items: center; min-width: 180px; }
.sp-margin > span:first-child { min-width: 55px; text-align: right; }
.sp-track { display: block; width: 120px; height: 9px; background: #e7edf4; border-radius: 8px; overflow: hidden; }
.sp-track i { display: block; height: 100%; border-radius: 8px; background: #45b989; }
.rp-red .sp-track i { background: #ff5975; }
.sp-ledger { display: grid; grid-template-columns: repeat(7, minmax(0, 1fr)); background: white; border-radius: 8px; padding: 16px 6px; margin-bottom: 14px; }
.sp-ledger-item { display: flex; align-items: center; gap: 10px; padding: 0 10px; min-width: 0; border-right: 1px solid #e7effb; }
.sp-ledger-item:last-child { border: 0; }
.sp-ledger-item > div { min-width: 0; display: flex; flex-direction: column; gap: 3px; }
.sp-ledger-item > div > span:first-child { font-size: 10px; color: #6882aa; line-height: 1.35; }
.sp-ledger .sp-icon { width: 42px; height: 42px; font-size: 22px; }
.sp-ledger strong { font-size: 15px; line-height: 1.3; overflow-wrap: anywhere; }
.sp-alert { padding: 12px; background: #ffe8ed; color: #ff063a; margin-bottom: 16px; border-left: 3px solid #ff063a; border-radius: 6px; font-size: 14px; }
.sp-alert .b-icon { margin-right: 8px; }
.sp-chart-controls { display: flex; gap: 12px; flex-wrap: wrap; }
.sp-chart-controls input, .sp-chart-controls select, .sp-expenses select { border: 1px solid #d8e4f3; background: #fafcff; color: #11264f; border-radius: 6px; height: 34px; padding: 4px 10px; font-size: 12px; }
.sp-chart-controls input { width: 145px; }
.sp-expenses select { width: 200px; height: 30px; }
.sp-status { display: inline-flex; gap: 5px; align-items: center; font-size: 10px; padding: 4px 8px; border-radius: 20px; }
.sp-status::before { content: ''; width: 7px; height: 7px; border-radius: 50%; background: currentColor; }
.sp-status-ok { background: #e5f8ef; color: #008c5a; }
.sp-status-pending { background: #fff4df; color: #bc7600; }
.sp-add { background: #0668ff; color: white; }
.sp-add:hover { background: #0056dc; }
.sp-row-actions { display: flex; gap: 8px; justify-content: center; }
.sp-action { display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border-radius: 6px; border: 0; background: #edf5ff; color: #1356c4; }
.sp-edit { background: #eaf8fb; color: #0099b0; }
.sp-delete { background: #ffedf0; color: #ff1749; }
.sp-action:hover { filter: brightness(0.95); }
.sp-action:disabled { opacity: 0.5; }
.service-profit button:focus-visible, .service-profit input:focus-visible, .service-profit select:focus-visible { outline: 2px solid #246aff; outline-offset: 2px; }
@media (max-width: 1300px) {
  .sp-spark { display: none; }
  .sp-ledger { grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 18px 0; }
  .sp-ledger-item:nth-child(4) { border: 0; }
}
@media (max-width: 900px) {
  .service-profit .rp-summary-3 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .service-profit .rp-filters { gap: 12px; }
}
@media (max-width: 600px) {
  .service-profit { padding: 12px; }
  .service-profit .rp-summary-3 { grid-template-columns: 1fr; }
  .service-profit .rp-title { font-size: 18px; }
  .service-profit .rp-title .b-icon { display: none; }
  .service-profit .rp-back { margin-right: 12px; }
  .service-profit .rp-filter { min-width: 0; flex: 1 1 140px; }
  .service-profit .rp-filter-grow { flex-basis: 100%; }
  .service-profit .rp-card-value { font-size: 22px; }
  .service-profit .rp-block-title { font-size: 16px; }
  .service-profit .rp-section, .service-profit .rp-chart-wrap { padding: 12px; }
  .sp-ledger { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .sp-ledger-item:nth-child(even) { border: 0; }
  .sp-chart-controls { width: 100%; gap: 8px; }
  .sp-chart-controls input { flex: 1; min-width: 0; width: 120px; }
  .sp-chart-controls select { width: 100%; }
  .sp-heading-icon { width: 32px; height: 32px; }
}
</style>
